import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lottie from 'lottie-web'
import BaiduMap from '@/components/vue-baidu-map'
import VuevideoPlayer from 'vue-video-player';


// 引入全局的样式文件
import './assets/css/global.less'
import './assets/css/transtion.less'



// 全局方法挂载
Vue.prototype.lottie = lottie

// 成功提示信息
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}
// 失败提示信息
Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.use(VuevideoPlayer);
Vue.use(ElementUI)
//全局注册百度地图
Vue.use(BaiduMap, {
  ak: 'tcri78g80IskCBC5zzxiRg3qoVwcL8c8'
})

// 中央事件总线bus
Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false

let vm = new Vue({
  router,
  store,
  render: h => h(App),
  // beforeCreate() {
  //   Vue.prototype.$bus = this
  // }
}).$mount('#app')
